import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "authLayout__rightSide loginView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/payRevision/logo.png",
  alt: ""
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "loginView__ortherControl"
}
const _hoisted_4 = {
  key: 1,
  class: "loginView__ortherControl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      class: "loginView__form",
      model: _ctx.formData,
      rules: _ctx.rules,
      onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_form_item, { name: "mobile" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.mobile,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mobile) = $event)),
              size: "large",
              type: "number",
              name: "mobile",
              placeholder: "手机号",
              min: 1,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClearError('mobile')))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  type: "mobile",
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' }),
                  size: "18px"
                }, null, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_a_form_item, { name: "loginPassword" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.loginPassword,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.loginPassword) = $event)),
              type: "password",
              name: "loginPassword",
              size: "large",
              autocomplete: "false",
              placeholder: "密码",
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClearError('mobile')))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, {
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' })
                }, null, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.loginBy === 'password']
        ]),
        _withDirectives(_createVNode(_component_a_form_item, { name: "verificationCode" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.verificationCode,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.verificationCode) = $event)),
              class: "loginView__code",
              name: "verificationCode",
              size: "large",
              type: "number",
              autocomplete: "false",
              placeholder: "验证码"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, {
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' })
                }, null, 8, ["style"])
              ]),
              suffix: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "link",
                  disabled: _ctx.codeSending || _ctx.sendCounting,
                  onClick: _ctx.onSendCaptcha
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.sendText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.loginBy === 'code']
        ]),
        (_ctx.loginBy === 'password')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: { name: 'auth.forgot_pwd' },
                style: {"color":"#999"},
                class: "forge-password"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("忘记密码?")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                to: { name: 'auth.login_by_code', query: _ctx.route.query },
                class: "forge-password"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("验证码登录")
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'auth.login_by_pwd' },
                class: "forge-password"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("密码登录")
                ]),
                _: 1
              }, 8, ["to"])
            ])),
        _createVNode(_component_a_button, {
          size: "large",
          type: "primary",
          class: "login-button",
          loading: _ctx.submiting,
          disabled: _ctx.submiting,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["model", "rules", "onSubmit"])
  ]))
}